import { render, staticRenderFns } from "./SnackbarAlert.vue?vue&type=template&id=4cd0c990"
import script from "./SnackbarAlert.vue?vue&type=script&lang=js"
export * from "./SnackbarAlert.vue?vue&type=script&lang=js"
import style0 from "./SnackbarAlert.vue?vue&type=style&index=0&id=4cd0c990&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports